import axios from 'axios';
import interceptors from './interceptors';

export const http = axios.create();

http.defaults.headers.post['Content-Type'] = 'application/json';

export function setToken(token) {
  if (token) {
    http.defaults.headers.common.Authorization = `Bearer ${token}`;
  }
}

export function removeToken() {
  delete http.defaults.headers.common.Authorization;
}

export function setCountryCode(countryCode) {
  http.defaults.headers.common['Country-Code'] = countryCode || 'KR';
}

export function removeCountryCode() {
  delete http.defaults.headers.common['Country-Code'];
}

export function setAcceptLanguage(language) {
  http.defaults.headers.common['accept-language'] = language || 'ko';
}

export default function install(Vue, { store, router }) {
  interceptors(http, store, router);

  Object.defineProperty(Vue.prototype, '$http', {
    get() {
      return http;
    },
  });
}
